export default "__VITE_ASSET__bca3cacd__"